import { createRemote } from '../atomic';
import ENTITIES from '..';

export function sendMeetingResult(store, data) {
  createRemote(store, ENTITIES.MEETING_RESULT, data);
}
